import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccountBalance = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_15_8511",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_15_8511)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4.79158 14.1666V7.91664H6.04158V14.1666H4.79158ZM9.37491 14.1666V7.91664H10.6249V14.1666H9.37491ZM2.30762 17.0833V15.8333H17.6922V17.0833H2.30762ZM13.9582 14.1666V7.91664H15.2082V14.1666H13.9582ZM2.30762 6.24997V5.06414L9.99991 1.2981L17.6922 5.06414V6.24997H2.30762ZM5.26262 4.99997H14.7372L9.99991 2.7083L5.26262 4.99997Z",
			fill: "#152A58"
		})
	})]
});
export default SvgAccountBalance;
